import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MsalService} from '@azure/msal-angular';
import {AuthService} from '../../../services/auth.service';

@Component({
    selector: 'app-ms-office-connection',
    templateUrl: './ms-office-connection.component.html',
    styleUrls: ['./ms-office-connection.component.scss']
})
export class MsOfficeConnectionComponent implements OnInit {
    @Input() studentFormGroup: FormGroup;
    @Output() setStudentInfo: EventEmitter<any> = new EventEmitter<any>()
    isLoading: boolean;
    isIframe: boolean;
    loginDisplay: boolean;
    account: any;
    student: any;

//#region Life cycle hooks
    constructor(private msalAuthService: MsalService,
                private authService: AuthService) {
        this.isLoading = false;
        this.loginDisplay = false;
    }

    ngOnInit(): void {
        this.isIframe = window !== window.parent && !window.opener;
    }

    //#endregion

    onLogin() {
        this.msalAuthService.loginPopup()
            .subscribe({
                next: async (result: any) => {
                    console.log(result);
                    if (result && result.account.username) {
                        this.account = result.account;
                        this.student = await this.authService.office365StudentParentLogin(result.account.username, result.uniqueId, result.accessToken);
                        this.setStudent();
                        this.setStudentInfo.emit(this.student);
                    }
                    this.setLoginDisplay();
                },
                error: (error) => console.log(error)
            });
    }

    setStudent() {
        console.log(this.student);
        this.studentFormGroup.setValue({studentEmail: this.student.email, studentId: +this.student.id});
    }

    onLogout() {
        this.msalAuthService.logoutPopup(this.account).subscribe({
            next: () => {
                this.setLoginDisplay(false);
            }
        });
    }

    setLoginDisplay(status: boolean = true) {
        if (!status) {
            this.loginDisplay = false;
            return;
        }
        this.loginDisplay = this.msalAuthService.instance.getAllAccounts().length > 0;
    }
}
